import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentUser: null,
  isAdmin: false,
  needsVerification: false,
  userInfo: null
};

// userInfo example: {
//     "userId": "user123",
//     "username": "John Doe",
//     "email": "user@example.com", 
//     "createdAt": [
//         2025,
//         1,
//         1,
//         12,
//         0,
//         0,
//         0
//     ],
//     "updatedAt": [
//         2025,
//         1,
//         1,
//         12,
//         0,
//         0,
//         0
//     ],
//     "active": true,
//     "admin": false,
//     "emailVerified": true,
//     "lastLogin": [
//         2025,
//         1,
//         1,
//         12,
//         0,
//         0,
//         0
//     ],
//     "picture": "https://example.com/default-avatar.png",
//     "dailyMessagesLimit": 100,
//     "currentAiModel": "gpt-4o-mini",
//     "premium": false,
//     "premiumAiModel": "gpt-4o",
//     "premiumMessagesLimit": 100
// }

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setCurrentUser: (state, action) => {
      state.currentUser = action.payload;
    },
    setIsAdmin: (state, action) => {
      state.isAdmin = action.payload;
    },
    setNeedsVerification: (state, action) => {
      state.needsVerification = action.payload;
    },
    setUserInfo: (state, action) => {
      state.userInfo = action.payload;
    },
    clearUserInfo: (state) => {
      state.userInfo = null;
    }
  }
});

export const { 
  setCurrentUser, 
  setIsAdmin, 
  setNeedsVerification, 
  setUserInfo,
  clearUserInfo 
} = userSlice.actions;

export default userSlice.reducer; 